function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3392",
  "data-name": "Group 3392",
  transform: "translate(-893 -909.781)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3170",
  "data-name": "Group 3170",
  transform: "translate(600.646 587.885)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ret\\xE2ngulo_1917",
  "data-name": "Ret\\xE2ngulo 1917",
  transform: "translate(293.079 325.637)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1010",
  "data-name": "Group 1010",
  transform: "translate(0 0.025)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1009",
  "data-name": "Group 1009"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1008",
  "data-name": "Group 1008"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_92",
  "data-name": "Line 92",
  y1: 8.084,
  fill: "#2491d2"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1013",
  "data-name": "Group 1013",
  transform: "translate(0.275 7.634)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1012",
  "data-name": "Group 1012"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1011",
  "data-name": "Group 1011"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1123",
  "data-name": "Path 1123",
  d: "M293.354,333.747",
  transform: "translate(-293.354 -333.747)",
  fill: "#f3a73b"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1016",
  "data-name": "Group 1016",
  transform: "translate(0.275)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1015",
  "data-name": "Group 1015"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1014",
  "data-name": "Group 1014"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1124",
  "data-name": "Path 1124",
  d: "M297.3,334.247h-3.949v-1H296.3v-6.134h-2.949v-1H297.3Z",
  transform: "translate(-293.354 -326.113)",
  fill: "#f3a73b"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Ret\\xE2ngulo_1917-2",
  "data-name": "Ret\\xE2ngulo 1917",
  transform: "translate(311.098 325.637)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1019",
  "data-name": "Group 1019",
  transform: "translate(4.5 0.025)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1018",
  "data-name": "Group 1018"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1017",
  "data-name": "Group 1017"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_93",
  "data-name": "Line 93",
  y2: 8.084,
  fill: "#2491d2"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1022",
  "data-name": "Group 1022",
  transform: "translate(4.225 0.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1021",
  "data-name": "Group 1021"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1020",
  "data-name": "Group 1020"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1125",
  "data-name": "Path 1125",
  d: "M316.793,326.613",
  transform: "translate(-316.793 -326.613)",
  fill: "#f3a73b"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1025",
  "data-name": "Group 1025"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1024",
  "data-name": "Group 1024"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1023",
  "data-name": "Group 1023"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1126",
  "data-name": "Path 1126",
  d: "M316.518,334.247h-3.949v-8.134h3.949v1h-2.949v6.134h2.949Z",
  transform: "translate(-312.568 -326.113)",
  fill: "#f3a73b"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1028",
  "data-name": "Group 1028",
  transform: "translate(292.354 321.896)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1027",
  "data-name": "Group 1027"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1026",
  "data-name": "Group 1026"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1127",
  "data-name": "Path 1127",
  d: "M315.883,337.9H292.354v-16h23.529Zm-22.588-.941h21.647V322.837H293.3Z",
  transform: "translate(-292.354 -321.896)",
  fill: "#f3a73b"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1031",
  "data-name": "Group 1031",
  transform: "translate(300.313 325.66)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1030",
  "data-name": "Group 1030"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1029",
  "data-name": "Group 1029"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1128",
  "data-name": "Path 1128",
  d: "M304.854,333.8a3.841,3.841,0,1,1,3.807-3.841A3.828,3.828,0,0,1,304.854,333.8Zm0-6.682a2.841,2.841,0,1,0,2.807,2.841A2.827,2.827,0,0,0,304.854,327.113Z",
  transform: "translate(-301.048 -326.113)",
  fill: "#f3a73b"
}))))));

function SvgMatchtracker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.529,
    height: 16,
    viewBox: "0 0 23.529 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchtracker);
export default __webpack_public_path__ + "static/media/matchtracker.57f2163f.svg";
export { ForwardRef as ReactComponent };